export class DataObject {
    _type;
}

export class DataObjectFactory {
    _cache = {};
    _instance = null;

    constructor() {}

    static getInstance() {
        if (this._instance == null) {
            this._instance = new DataObjectFactory();
        }

        return this._instance;
    }
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @param {function} constructor Constructor of DataObject.
     * @param {Object, null} data Data to populate the DataObject object with. Only populates own properties found in data object.
     */
    construct(constructor, data = null) {
        let dataObj = new constructor();
        let dataObjKeys = [];

        if (dataObj._type != null) {
            if (this._cache[dataObj._type] != null) {
                dataObjKeys = this._cache[dataObj._type];
            } else {
                dataObjKeys = Object.keys(dataObj);
                this._cache[dataObj._type] = dataObjKeys;
            }
        } else {
            dataObjKeys = Object.keys(dataObj);
        }

        if (data != null) {
            dataObjKeys.forEach((key) => {
                if (data.hasOwnProperty(key)) {
                    dataObj[key] = data[key];
                }
            });
        }
        return dataObj;
    }

    constructWithMapper(constructor, mapper, data = null) {
        return this.construct(constructor, data ? mapper(data) : null);
    }
}
export const dataFactoryInstance = DataObjectFactory.getInstance();

export class AppendableDataObject extends DataObject {
    /**
     * Creates a new instance of a AppendableDataObject.
     * @function
     * @param {Object, null} data Data to populate the AppendableDataObject object with. Merges own properties with data properties.
     */
    constructor(data = null) {
        super();
        if (data != null) {
            Object.assign(this, data);
        }
    }
}
